define(["exports", "../core/l10n", "hyperhtml"], function (_exports, _l10n, _hyperhtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<p><em>", "</em></p>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/informative";
  _exports.name = name;
  const localizationStrings = {
    en: {
      informative: "This section is non-normative."
    },
    nl: {
      informative: "Dit onderdeel is niet normatief."
    }
  };
  const lang = _l10n.lang in localizationStrings ? _l10n.lang : "en";
  const l10n = localizationStrings[lang];

  function run() {
    Array.from(document.querySelectorAll("section.informative")).map(informative => informative.querySelector("h2, h3, h4, h5, h6")).filter(heading => heading).forEach(heading => {
      heading.after((0, _hyperhtml.default)(_templateObject(), l10n.informative));
    });
  }
});
//# sourceMappingURL=informative.js.map